import React, { lazy } from 'react';
import { CheckIcon, CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const productImage = 'https://cdn.magicpatterns.com/uploads/aqG9HQC66KMBb9cVwR5wEE/68c09047-ad60-482d-94c4-9c036055a5e8-Photoroom.png';
const items = ['12 tomos completos', '5 bonos estratégicos', '400+ sesiones listas para ejecutar', '250+ ejercicios y juegos', 'Primaria y Secundaria', 'Acceso de por vida'];
export function PricingSection() {
  return <section id="pricing" className="bg-[#f4f8f5] px-5 py-20" data-id="element-141" data-mp="1s93yxa3hwh1w">
      <div className="mx-auto max-w-xl text-center" data-id="element-142" data-mp="1sbq3r1z04igf">
        <p className="inline-block bg-[#09281d] px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-143" data-mp="1x9rorsfzmruj">
          Oferta de lanzamiento por tiempo limitado
        </p>
        <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-none text-[#09281d] sm:text-5xl" data-id="element-144" data-mp="2v8lvorjambz">
          Todo incluido,{' '}
          <span className="text-emerald-700" data-id="element-145" data-mp="7ubq56zowoiw">un solo precio.</span>
        </h2>
        <p className="mt-3 text-sm font-semibold text-slate-600" data-id="element-146" data-mp="1mhpzs88hzcfs">
          Sin extras. Sin sorpresas.
        </p>
        <article className="mt-10 overflow-hidden border border-emerald-950/10 bg-white text-center shadow-xl" data-id="element-147" data-mp="1hodfuberjttd">
          <header className="border-t-4 border-emerald-500 bg-[#09281d] px-6 py-7" data-id="element-148" data-mp="1cr4u60uep7nd">
            <h3 className="font-display text-3xl font-bold uppercase text-white" data-id="element-149" data-mp="17td3fa5hzrkr">
              PACK EDUCACIÓN FÍSICA LISTA™
            </h3>
            <p className="mt-2 text-sm font-semibold text-emerald-300" data-id="element-150" data-mp="20gfx9oz8be4o">
              12 Tomos + 5 Bonos Estratégicos
            </p>
          </header>
          <div className="p-7 sm:p-10" data-id="element-151" data-mp="1vg1t4i0r0obx">
            <img src={productImage} alt="Pack Educación Física Lista: colección de 12 tomos, 5 bonos y acceso digital" width={1536} height={1024} loading="lazy" className="mx-auto -mt-4 mb-4 w-full max-w-lg object-contain" data-id="element-152" data-mp="1rfrl6ztebnuf" />
            <div id="offer-details" className="mb-8 scroll-mt-3 border-y border-emerald-950/10 py-7" data-id="element-153" data-mp="hh8c3k45ufap">
              <p className="mb-5 text-xs font-bold uppercase tracking-widest text-[#09281d]" data-id="element-154" data-mp="mgcm2cywsh23">
                Qué incluye
              </p>
              <ul className="grid gap-3 text-left sm:grid-cols-2" data-id="element-155" data-mp="cioq5jpkh3ic">
                {items.map(item => <li key={item} className="flex items-center gap-2 text-sm font-semibold text-[#09281d]" data-id="element-156" data-mp="3uwxt3o7zd02k">
                    <span className="grid h-5 w-5 place-items-center rounded-full bg-emerald-100" data-id="element-157" data-mp="3k395szqtwjo">
                      <CheckIcon className="h-3.5 w-3.5 text-emerald-700" data-id="element-158" data-mp="3kwdteq0403mg" />
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="mt-7" data-id="element-159" data-mp="3c06551hhtws6">
              <p className="text-sm font-semibold text-slate-600" data-id="element-160" data-mp="3fznbdx4quxye">
                Oferta de lanzamiento
              </p>
              <div className="mt-1 flex items-baseline justify-center text-[#09281d]" data-id="element-161" data-mp="2xbwdthsbaerm">
                <span className="font-display text-5xl font-bold" data-id="element-162" data-mp="2sd1wyldwn0a5">$</span>
                <strong className="font-display text-8xl font-bold leading-none tracking-tight" data-id="element-163" data-mp="36bjc3upqv4gg">
                  17
                </strong>
                <span className="ml-2 text-sm font-bold text-slate-600" data-id="element-164" data-mp="31b560i7pe4l2">
                  USD
                </span>
              </div>
              <p className="mt-2 text-sm font-bold text-[#09281d]" data-id="element-165" data-mp="3baw0wl06ello">
                Pagás en tu moneda local
              </p>
              <div className="mt-3 flex flex-wrap justify-center gap-3" data-id="element-166" data-mp="3p2ssmnxxmthj">
                <span className="bg-emerald-500 px-3 py-1.5 text-xs font-bold uppercase tracking-widest text-white" data-id="element-167" data-mp="3l0nxtlvqzqtb">
                  Hoy solo $17
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-slate-600" data-id="element-168" data-mp="2vcadtqw3hab">
                  Pago único
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-slate-600" data-id="element-169" data-mp="hym2kc7x6jcp">
                  Acceso de por vida
                </span>
              </div>
            </div>
            <a href="https://pack-e-f-lista.impultienda.ar/checkout" className="cta-button -mx-2 mt-6 block w-[calc(100%+1rem)] rounded-2xl px-6 py-5 text-lg font-bold leading-tight sm:text-xl" data-id="element-170" data-mp="qpw8z441i9yt">
              <span className="block" data-id="element-171" data-mp="3v674kn6jvad1">OBTENER ACCESO</span>
              <span className="block" data-id="element-172" data-mp="30a9efjr9sqa">INMEDIATO</span>
            </a>
            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-slate-600" data-id="element-173" data-mp="32myrdruf5dd">
              <ShieldCheckIcon className="h-4 w-4 text-emerald-700" data-id="element-174" data-mp="cyzoy1o6j13d" /> Garantía
              de devolución de 7 días
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 border-t border-emerald-950/10 pt-6 text-xs font-bold text-slate-600" data-id="element-175" data-mp="1je0e9oip8l0z">
              <span className="flex gap-1" data-id="element-176" data-mp="1ofzif0m9jlyz">
                <LockKeyholeIcon className="h-4 w-4" data-id="element-177" data-mp="38wgw3h8vsxu9" /> Pago seguro
              </span>
              <span className="flex gap-1" data-id="element-178" data-mp="33wkqjdkjcycl">
                <ZapIcon className="h-4 w-4" data-id="element-179" data-mp="33xw2i0o4xces" /> Acceso inmediato
              </span>
              <span className="flex gap-1" data-id="element-180" data-mp="2z52vt793vu02">
                <CreditCardIcon className="h-4 w-4" data-id="element-181" data-mp="2u7au5linstio" /> Pago online
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}